<template>
<b-list-group flush>
<b-list-group-item>
    <b-row>       
      <!-- <b-col cols="12">
        <b-form-group
          label="ที่อยู่: "
          label-cols-md="4"
        >
          <span class="row col-form-label" v-text="this.fullAddress" />
        </b-form-group>
      </b-col> -->

      <b-col cols="12" md="12">
        <b-form-group label="ที่อยู่: " label-cols-md="4">
          <span class="row col-form-label" v-text="address.address1" />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="แขวง/ตำบล: " label-cols-md="4">
          <span class="row col-form-label " v-text="address.tumbon" />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="เขต/อำเภอ: " label-cols-md="4">
          <span class="row col-form-label" v-text="address.ampher" />
        </b-form-group>
      </b-col>

      <b-col cols="12" md="6">
        <b-form-group label="จังหวัด: " label-cols-md="4">
          <span class="row col-form-label" v-text="address.province" />
        </b-form-group>
      </b-col>



      <b-col cols="12" md="6">
        <b-form-group label="รหัสไปรษณีย์: " label-cols-md="4">
          <span class="row col-form-label " v-text="address.zipcode" />
        </b-form-group>
      </b-col>
    </b-row>
  </b-list-group-item>
</b-list-group>
  
</template>

<script>
import {
  BFormGroup,
  BRow,
  BCol,
  BFormInput,
  BListGroup,
  BListGroupItem,
  BButton,
} from "bootstrap-vue";

export default {
  components: {
    BButton,
    BFormGroup,
    BRow,
    BCol,
    BFormInput,
    BListGroup,
    BListGroupItem,
  },
  props: {
    address: {
      type: Object,
      required: true,
    },
  },
  computed: {    
    fullAddress() {
      return [
        this.address?.address1,
        this.address?.address2,
      ]
        .filter(Boolean)
        .join(" ");
    },
  },
};
</script>

<style></style>
